import React from "react";
import DeleteButton from "../Buttons/DeleteButton";
import EditButton from "../Buttons/EditButton";

const MaterialTableActionCellRenderer = ({
    rowIndex,
    handleDelete,
    handleEdit,
    value,
}) => (
    <div>
        <DeleteButton
            onClick={(event) => handleDelete(event, rowIndex)}
            disabled={value}
            tippy={true}
        />
        <EditButton onClick={() => handleEdit(rowIndex)} tippy={true} />
    </div>
);

export default MaterialTableActionCellRenderer;
